import {store} from '../../services/vuex';

export function dispatchModuleMutations<T>(
  moduleName: string,
  mutationName: string | number | symbol,
  params?: T
): void {
  store.commit(`${moduleName}/${String(mutationName)}`, params);
}
